export const displayMoneyString = (decimalDollars) => {
  // Only show pennies only if there are any, otherwise don't show decimal place
  if (decimalDollars % 1 !== 0) {
    return `$${decimalDollars.toFixed(2)}`;
  }

  return `$${decimalDollars}`;
};
